function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.25 15.25v-8.5h-8.5",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "square"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 8l-9 9",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "square",
  strokeLinejoin: "round"
});

function SvgLinkExternalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgLinkExternalIcon;